import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
	STR_LATEST_ARTICLES,
	STR_MENU_ARTICLES,
	STR_MENU_STORIES,
	STR_MENU_UTILITIES,
	STR_MORE_ARTICLES,
	STR_NO_DATA_FOUND,
	STR_NO_MESSAGES,
	STR_TAB_MY_ORDERS
} from "../Strings";
import OnePharmacyOrder from '../ones/OnePharmacyOrder';
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import LoginView from '../views/LoginView';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);



	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getMyPharmacyOrders();
		setReady(true);
	}


	useEffect(() => {
		init();
	}, [])

	if(appContext.auth && appContext.currentUserData) {
		if (ready) {
		
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingTop: "20px",
						paddingBottom: "40px",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
	
						<h6
							className="mSectionTitle"
						>
							{STR_TAB_MY_ORDERS[appContext.language]}
						</h6>
	
						{
							(appContext.myPharmacyOrders && appContext.myPharmacyOrders.length > 0) ?
							appContext.myPharmacyOrders.map((item, i) => {
								return (
									<OnePharmacyOrder key={i} data={item}/>
								)
							})
							:
							<h6
								style={{
									fontSize: "14px",
								}}
							>
								{STR_NO_DATA_FOUND[appContext.language]}
							</h6>
						}
	
	
					</div>
	
	
				</div>
			)
			
		} else {
			return (
				<div
					className="mSupportLoading"
					style={{
						width: "100%",
						height: "100%",
					}}
				>
					{getInlineLoader()}
				</div>
			);
		}
	} else {
		return <LoginView/>
	}

	
}